<template>
  <emd-modal
    has-header
    scrollable
    open
    @close="closeClick"
  >
    <template #header>
      <emd-text
        size="section"
        data-testid="modal-header"
      >
        {{ $t('modalheader') }}
      </emd-text>
    </template>
    <template #content>
      <installments-table
        :installments="installments"
        class="without-padding"
      />
    </template>
  </emd-modal>
</template>

<script>
import { EmdModal, EmdText } from 'emerald-vue/src/components'
import InstallmentsTable from './InstallmentsTable'

export default {
  name: 'InstallmentsModal',

  components: {
    EmdModal,
    EmdText,
    InstallmentsTable
  },

  props: {
    isModalOpen: Boolean,
    isActionDisabled: Boolean,
    installments: {
      type: Array,
      required: true
    }
  },

  methods: {
    closeClick () {
      this.$emit('closeClick')
    }
  }
}
</script>

<style scoped>
:deep(.emd-container__content) {
  padding: 0;
}
</style>

<i18n>
    {
      "pt-BR": {
        "modalheader": "Detalhes do parcelamento"
      },
      "en-US": {
        "modalheader": "Installments details"
      }
    }
</i18n>
